import { render, staticRenderFns } from "./dashboard_management.vue?vue&type=template&id=c41b0dec&scoped=true"
import script from "./dashboard_management.vue?vue&type=script&lang=js"
export * from "./dashboard_management.vue?vue&type=script&lang=js"
import style0 from "./dashboard_management.vue?vue&type=style&index=0&id=c41b0dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41b0dec",
  null
  
)

export default component.exports